export default "__VITE_ASSET__DTLXSExg__"